import React from 'react';

interface MobileHeaderProps {
  title: string;
  subtitle?: string;
  showFilters?: boolean;
  onToggleFilters?: () => void;
  totalItems?: number;
  className?: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ 
  title, 
  subtitle, 
  showFilters = false,
  onToggleFilters,
  totalItems,
  className = ""
}) => {
  return (
    <div className={`bg-white shadow-sm border-b border-gray-200 ${className}`}>
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <h1 className="text-lg font-semibold text-gray-900 truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1 truncate">
                {subtitle}
              </p>
            )}
            {totalItems !== undefined && (
              <p className="text-xs text-gray-500 mt-1">
                {totalItems} objet{totalItems > 1 ? 's' : ''}
              </p>
            )}
          </div>
          
          {onToggleFilters && (
            <button
              onClick={onToggleFilters}
              className={`ml-3 p-2 rounded-lg transition-colors ${
                showFilters 
                  ? 'bg-blue-100 text-blue-600' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
              title={showFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
            >
              <span className="text-lg">
                {showFilters ? '✕' : '🔍'}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
